import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mosque-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M10 5.58569V7.68228C11.0749 6.06551 12.913 4.9999 15 4.9999C17.973 4.9999 20.4409 7.16219 20.917 9.9999H22V21.9999H2V5.58569L6 1.58569L10 5.58569Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13 15V21H17V15H13Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6.00391 9V9.00391H6M13 21V15H17V21H13Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 21H3V6L6 3L9 6V11M9 21V11M9 21H21V11H20M9 11H10M10 11H20M10 11C10 8.23858 12.2386 6 15 6M20 11C20 8.23858 17.7614 6 15 6M15 6V4.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Mosque1 = Vue.extend<IconProps>({
  name: 'Mosque1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'mosque-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Mosque1;
